module.exports = __webpack_public_path__ + "static/media/GrowthArrow.43c3777a.svg";